/**
 * GroundTruth Adapter
 *
 * Adapts standardized event payloads into GroundTruth pixel events.
 *
 * The GroundTruth Web Engagement Pixel automatically tracks page views,
 * scrolls, clicks and time on site once loaded. On top of that the Pixel
 * Manager sends the e-commerce signals GroundTruth supports: the "cart"
 * event when a product is added to the cart and the "purchase" event on
 * the order confirmation page, both carrying a numeric amount.
 *
 * @see https://help.groundtruth.com/hc/en-us/articles/43656481694483-Install-GroundTruth-Pixel-Manually
 */

(function (pmw, undefined) {

	class GroundTruthAdapter {

		/**
		 * Adapt an event for GroundTruth
		 * @param {Object} eventData - Standardized event data
		 * @param {string} eventName - Standardized event name
		 * @param {Object} context - Additional context
		 * @returns {Object|null} - GroundTruth formatted event or null to skip
		 */
		adapt(eventData, eventName, context) {
			const methodName = `adapt${this.toPascalCase(eventName)}`;

			if (typeof this[methodName] === "function") {
				return this[methodName](eventData, context);
			}

			// GroundTruth does not track every standardized event - skip the rest.
			return null;
		}

		toPascalCase(str) {
			if (typeof str !== "string") return "";
			return str.replace(/(^|_)(\w)/g, (_, __, c) => c.toUpperCase());
		}

		/**
		 * Round a value to two decimals; falls back to 0 because the GroundTruth
		 * event schema requires a numeric amount.
		 */
		toAmount(value) {
			const amount = Math.round(Number(value) * 100) / 100;
			return Number.isFinite(amount) ? amount : 0;
		}

		/**
		 * Adapt AddToCart event
		 *
		 * GroundTruth's "cart" event carries the value of the products added.
		 */
		adaptAddToCart(eventData, context) {
			const quantity = Number(eventData.quantity) || 1;

			return {
				event_name: "cart",
				event_data: {
					amount: this.toAmount(Number(eventData.product?.price) * quantity),
				},
			};
		}

		/**
		 * Adapt Purchase event
		 *
		 * GroundTruth's "purchase" event carries the order total.
		 */
		adaptPurchase(eventData, context) {
			return {
				event_name: "purchase",
				event_data: {
					amount: this.toAmount(pmwDataLayer?.order?.value?.total),
				},
			};
		}
	}

	// Register the adapter with capabilities
	const adapter = new GroundTruthAdapter();
	pmw.registerAdapter("groundtruth", adapter, {
		supportsS2S: false,
		supportsEventDeduplication: false,
		isActive: () => pmwDataLayer?.pixels?.groundtruth?.gtid ? true : false,
	});

}(window.pmw = window.pmw || {}));
